export function stopPreviewVideo(time) {
    const   previewBlock = document.querySelector('.preview'),
        previewVideo = document.getElementById('video-preview');

    previewVideo.pause();

    setTimeout(() => {
        previewBlock.classList.add('hidden');
        document.body.style.overflow = null;
    }, time)
}
